const HOLDINGS_PAGE_LIMIT = 10

export const portfolioKeys = {
  all: ['portfolio'] as const,
  overview: () => [...portfolioKeys.all, 'overview'] as const,
  rentalIncomeSummary: () => [...portfolioKeys.all, 'rentalIncomeSummary'] as const,
  graphs: () => [...portfolioKeys.all, 'graph'] as const,
  // `fiscalYear` '' = the backend's default (current) fiscal year.
  graph: (type: 'value' | 'rental', fiscalYear = '') =>
    [...portfolioKeys.graphs(), type, fiscalYear] as const,
  holdingsSummary: () => [...portfolioKeys.all, 'holdings', 'summary'] as const,
  holdings: () => [...portfolioKeys.all, 'holdings', 'list'] as const,
  allocation: () => [...portfolioKeys.all, 'allocation'] as const,
  investmentDetails: () => [...portfolioKeys.all, 'investmentDetail'] as const,
  investmentDetail: (id: string) => [...portfolioKeys.investmentDetails(), id] as const,
}

export { HOLDINGS_PAGE_LIMIT }
